import { render } from "./PlusCallModal.vue?vue&type=template&id=27fbeef2&scoped=true"
import script from "./PlusCallModal.vue?vue&type=script&lang=js"
export * from "./PlusCallModal.vue?vue&type=script&lang=js"

import "./PlusCallModal.vue?vue&type=style&index=0&id=27fbeef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fbeef2"]])

export default __exports__